import React from 'react';

import ChevronDownIcon from 'icons/chevron-down.svg';
import ChevronUpIcon from 'icons/chevron-up.svg';
import PropTypes from 'prop-types';
import qs from 'qs';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import OptionChoice from 'components/application/OptionChoice';
import Options from 'components/application/Options';

export default function TrainingRegisterReportsSelector({
  filter,
  selectableReportTypes,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'trainingRegisterReports.TrainingRegisterReportsSelector',
  });

  const { t: i18nTShared } = useTranslation('components', {
    keyPrefix: 'trainingRegisterReports.shared',
  });

  const handleReportSelection = (type) => {
    const queryString = qs.stringify({
      tab: 'reports',
      type,
      filter,
    });

    window.open(`/personnel?${queryString}`, '_blank');
  };

  return (
    <Options
      align='center'
      btnToggle={(isOpen) => (
        <div className='tooltip-parent'>
          <OutlinedButton color='grey' onClick={() => {}} size='sm'>
            <span>{i18nT('button')}</span>
            <ChevronUpIcon
              className='-tw-mb-px -tw-mr-1.5'
              height={24}
              style={{ display: isOpen ? 'inline-block' : 'none' }}
              width={24}
            />
            <ChevronDownIcon
              className='-tw-mb-px -tw-mr-1.5'
              height={24}
              style={{ display: isOpen ? 'none' : 'inline-block' }}
              width={24}
            />
          </OutlinedButton>
        </div>
      )}
      listStyle='tw-w-52 tw-z-[99999] [&_li]:tw-border-none'
      toggleStyle='tw-inline-block'
    >
      {selectableReportTypes.map((reportType) => (
        <OptionChoice
          key={reportType}
          onClick={(setOptionsOpen) => {
            setOptionsOpen(false);
            handleReportSelection(reportType);
          }}
        >
          <a className='tw-text-wrap tw-text-m tw-font-medium tw-tracking-auto tw-text-grey-700 hover:tw-text-grey-700'>
            {i18nTShared(`reports.${reportType}.label`)}
          </a>
        </OptionChoice>
      ))}
    </Options>
  );
}

const resourceIdShape = PropTypes.shape({
  eq: PropTypes.string.isRequired,
});

TrainingRegisterReportsSelector.propTypes = {
  filter: PropTypes.shape({
    courseId: resourceIdShape,
    roleId: resourceIdShape,
  }),
  selectableReportTypes: PropTypes.array,
};
